module.exports = __webpack_public_path__ + "media/images/icon-error-9c345e3e1b0e8ba91636f3519dca1e92.svg";